import TabFeedItem from './TabFeedItem';

export default TabFeedItem;
